const CNPJ_LENGTH = 14;
const CNPJ_MASK_REGEX = /[.\-/]/g;

/** Remove máscara e normaliza para maiúsculas. CNPJs só numéricos legados recebem zeros à esquerda. */
export const normalizeCnpj = (cnpj: string): string => {
    const cleaned = cnpj.replace(CNPJ_MASK_REGEX, '').trim().toUpperCase();

    if (/^\d+$/.test(cleaned) && cleaned.length < CNPJ_LENGTH) {
        return cleaned.padStart(CNPJ_LENGTH, '0');
    }

    return cleaned;
};

/** Aceita letras e números para busca/cadastro de CNPJ (formato legado e alfanumérico). */
export const sanitizeCnpjInput = (value: string): string => {
    return value.replace(/[^0-9A-Za-z]/g, '').toUpperCase();
};

/** Formata CNPJ para exibição (XX.XXX.XXX/XXXX-XX). Suporta numérico e alfanumérico. */
export const formatCnpj = (cnpj: string): string => {
    if (!cnpj) {
        return cnpj;
    }

    const normalized = normalizeCnpj(cnpj);

    if (normalized.length !== CNPJ_LENGTH) {
        return normalized || cnpj;
    }

    return (
        normalized.substring(0, 2) +
        '.' +
        normalized.substring(2, 5) +
        '.' +
        normalized.substring(5, 8) +
        '/' +
        normalized.substring(8, 12) +
        '-' +
        normalized.substring(12)
    );
};

/** CNPJ do emitente extraído da chave da NF-e (sempre numérico). */
export const formatCnpjFromNFeKey = (chaveNFe: string): string => {
    return formatCnpj(chaveNFe.substring(6, 20));
};
